exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive-img{display:inline-block}.responsive-img>img{max-width:100%;max-height:100%}", ""]);

// exports
